module.exports = __webpack_public_path__ + "static/assets/3adc1e3e705ec30e961125d7c136db09.png";